import { Check, ChevronRight } from "lucide-react";

export function WizardStepper({ tabs, active, visited, onSelect, testPrefix }) {
  return (
    <div className="min-w-0 flex-1">
      <div className="mb-1.5 flex items-center gap-2">
        <span className="rounded-full bg-[#4E342E] px-2.5 py-0.5 text-[10px] font-bold text-white" data-testid={`${testPrefix}-progress`}>
          Step {active + 1} of {tabs.length}
        </span>
        <span className="text-xs font-semibold text-[#7B6157]">{tabs[active].label}</span>
      </div>
      <div className="flex items-center overflow-x-auto rounded-lg bg-[#F1EEE7] px-1" data-testid={`${testPrefix}s`}>
        {tabs.map((t, i) => {
          const done = visited.has(i) && i !== active;
          return (
            <div key={t.key} className="flex shrink-0 items-center">
              <button type="button" data-testid={`${testPrefix}-${t.key}`} onClick={() => onSelect(i)}
                className={`my-1 flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${i === active ? "bg-[#D9C7B2] text-[#3E2723] shadow-sm" : done ? "text-[#4E342E] hover:bg-[#EAE4D8]" : "text-[#84675B] hover:text-[#6D4C41]"}`}>
                {done
                  ? <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-[#2E7D32]"><Check size={10} className="text-white" /></span>
                  : <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-[9px] font-bold ${i === active ? "bg-[#4E342E] text-white" : "bg-[#E5DFD3] text-[#7B6157]"}`}>{i + 1}</span>}
                {t.label}
              </button>
              {i < tabs.length - 1 && <ChevronRight size={14} className="shrink-0 text-[#C0B3A4]" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
